import styled from 'styled-components/macro';
import { ellipsis } from 'polished';

import CompareBullet from 'components/styled/CompareBullet/CompareBullet';

export const DisplayName = styled.div<any>`
  ${({ isExpanded }) => !isExpanded && ellipsis()};
  margin-bottom: ${({ isExpanded }) => (isExpanded ? '0.25em' : 0)};
  display: flex;
  align-items: center;
  div {
    font-size: ${({ showMediumSize, isSmallScreen }) =>
      isSmallScreen ? '14px' : showMediumSize ? '13px' : '16px'};
    line-height: 1.25;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const StyledListItem = styled.li<any>`
  display: inline-flex;
  flex: 0 1 auto;
  width: ${({ isStacked }) => (isStacked ? '100%' : 'auto')};
  min-width: min-content;
  margin: ${({ theme, isStacked }) =>
    isStacked
      ? `0 ${theme.spacing.xxsmall} ${theme.spacing.small}`
      : `0 ${theme.spacing.small} 0 ${theme.spacing.xxsmall}`};

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }

  @media screen and (min-width: 840px) {
    margin: 0 ${({ theme }) => theme.spacing.medium} 0
      ${({ theme }) => theme.spacing.xsmall};
  }
`;

export const StyledList = styled.ul<any>`
  flex: 1 1 auto;
  display: ${({ isStacked }) => (isStacked ? 'block' : 'flex')};
  padding: ${({ theme }) => `${theme.spacing.xsmall} 0`};
  margin: 0 -${({ theme }) => theme.spacing.xxsmall};
  min-width: min-content; /** Needed for the proper display of ellipsis. */

  ${({ column }) =>
    column &&
    `
    display: flex;
    flex-direction: column;
    gap: 12px;
  `}

  @media screen and (min-width: 50em) {
    padding: ${({ theme }) => `${theme.spacing.small} 0`};
    margin: 0 -${({ theme }) => theme.spacing.xsmall};
  }
`;

export const CompareItem = styled.div<any>`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'flex-start')};
  font-size: 16px;

  @media screen and (min-width: 40em) {
    font-size: 1em;
  }
`;

export const CompareItemBody = styled.div`
  flex-grow: 1;
  color: white;
  min-width: 0%;

  p {
    color: inherit;
    white-space: normal;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

export const StyledCompareBullet = styled(CompareBullet)`
  margin-right: ${({ theme }) => theme.spacing.small};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0.3125em')};
  font-size: 16px;
`;

export const CopmareItemsWrapper = styled('div')`
  margin-bottom: 5px;
`;
